export default __webpack_public_path__ + "static/swapChat-90e660f7041a47163b7597a899ec59c5.svg";